export const PriceSummaryCurrencyFormatOptions = {
  canShowFreeLabel: true,
};
